const STORAGE_KEY = "22night_home_interests_v1";

export const HOME_INTERESTS = {
  EVENTS: "events",
  LIFESTYLE: "lifestyle",
  HOUSEMATES: "housemates",
  GAMES: "games",
  COMMUNITY: "community",
  SPIN: "spin",
};

const DEFAULT_SCORES = {
  [HOME_INTERESTS.EVENTS]: 0,
  [HOME_INTERESTS.LIFESTYLE]: 0,
  [HOME_INTERESTS.HOUSEMATES]: 0,
  [HOME_INTERESTS.GAMES]: 0,
  [HOME_INTERESTS.COMMUNITY]: 0,
  [HOME_INTERESTS.SPIN]: 0,
};

export function getHomeInterestScores() {
  if (typeof window === "undefined") return DEFAULT_SCORES;

  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    return { ...DEFAULT_SCORES, ...(saved.scores || {}) };
  } catch {
    return DEFAULT_SCORES;
  }
}

export function getPrimaryHomeInterest(scores = getHomeInterestScores()) {
  const ranked = Object.entries(scores).sort((a, b) => b[1] - a[1]);
  return ranked[0]?.[1] > 0 ? ranked[0][0] : HOME_INTERESTS.EVENTS;
}

export function recordHomeInterest(interest) {
  if (typeof window === "undefined" || !Object.prototype.hasOwnProperty.call(DEFAULT_SCORES, interest)) {
    return;
  }

  try {
    const now = Date.now();
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    const scores = { ...DEFAULT_SCORES, ...(saved.scores || {}) };
    const lastSeen = saved.lastSeen || {};

    // A route can render more than once during auth/layout updates. Count it
    // once per minute so the signal reflects intent instead of React renders.
    if (!lastSeen[interest] || now - lastSeen[interest] > 60000) {
      scores[interest] = Math.min((scores[interest] || 0) + 1, 50);
      lastSeen[interest] = now;
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ scores, lastSeen }));
    }
  } catch {
    // Personalization is optional; browsing must still work without storage.
  }
}

export function recordHomeInterestFromPath(pathname = "") {
  if (pathname.startsWith("/housemates")) {
    recordHomeInterest(HOME_INTERESTS.HOUSEMATES);
  } else if (pathname.startsWith("/lifestyle") || pathname.startsWith("/deal")) {
    recordHomeInterest(HOME_INTERESTS.LIFESTYLE);
  } else if (pathname.startsWith("/spin-and-win")) {
    recordHomeInterest(HOME_INTERESTS.SPIN);
  } else if (pathname.startsWith("/games")) {
    recordHomeInterest(HOME_INTERESTS.GAMES);
  } else if (pathname.startsWith("/community-chats")) {
    recordHomeInterest(HOME_INTERESTS.COMMUNITY);
  } else if (pathname.startsWith("/events") || pathname.startsWith("/single-event")) {
    recordHomeInterest(HOME_INTERESTS.EVENTS);
  }
}
